import { useSelector } from "react-redux";
import { AuthenticationSelector } from "redux/selectors/auth";

function useToken() {
  return useSelector(AuthenticationSelector.accessToken);
}

export default useToken;
